import React from "react"
import { Tooltip } from "antd"
import { Tag } from "components-design-system"
import "./TagGroup.scss"

const TagGroup = ({ tags, maxTags }) => {
  if (!tags || tags?.length === 0) return null
  return (
    <div className="tag-group">
      {tags.reduce((acc, tag, index) => {
        if (index < maxTags) {
          acc.push(
            <Tag
              key={tag}
              text={tag}
              readOnly
            >
              {tag}
            </Tag>
          )
        }
        return acc
      }, [])}
      {tags.length > maxTags - 1 && (
        <Tooltip
          title={tags.reduce((acc, tag, index) => {
            if (index > maxTags - 1) acc.push(<div key={tag}>{tag}</div>)
            return acc
          }, [])}
          placement="bottom"
        >
          <a className="tag-group-plus">{`+${tags.length - maxTags}`}</a>
        </Tooltip>
      )}
    </div>
  )
}

export default TagGroup
